<template>
    <el-card class="box-card" shadow="always"
        style="width: 380px; padding: 20px 30px 30px 30px;margin: 120px auto;background-color: #F2F6FC;">
        <span
            style="display: block;margin-bottom: 20px;text-align: center;font-size: 26px;color: #409EFF;font-weight: bold;">管理后台</span>
        <el-form :model="formData" :rules="rules" ref="formRef">
            <el-form-item prop="username" :error="errMsg.username">
                <el-input placeholder="用户名" v-model="formData.username" clearable>
                    <template slot="prepend">
                        <i class="el-icon-user fz-20 fc-blue"></i>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item prop="password" :error="errMsg.password">
                <el-input placeholder="密码" v-model="formData.password" show-password clearable>
                    <template slot="prepend">
                        <i class="el-icon-lock fz-20 fc-blue"></i>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item prop="captcha" :error="errMsg.captcha">
                <el-input placeholder="验证码" v-model="formData.captcha" clearable>
                    <template slot="prepend">
                        <i class="el-icon-picture-outline fz-20 fc-blue"></i>
                    </template>
                    <template slot="append">
                        <el-image style="width: 100px;height: 34px;cursor: pointer;" :src="img_base64"
                            @click="getCaptcha">
                            <div slot="error" class="image-slot" @click="getCaptcha">点击加载</div>
                        </el-image>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 0">
                <el-checkbox v-model="remember">下次自动登录</el-checkbox>
            </el-form-item>
            <el-button type="primary" @click="login"
                style="width: 100%; height: 48px; font-size: 16px; display: block">登
                录</el-button>
        </el-form>
    </el-card>
</template>
<script>
export default {
    name: "mainLogin",
    created() {
        let auth = this.$getAuth()
        if (auth.uuid) this.$router.push("/")
        this.getCaptcha()
    },
    data() {
        return {
            img_base64: "", //验证码图片
            errMsg: {},
            formData: {//表单
                username: '',
                password: '',
                captcha: '',
                captcha_id: '',
            },
            rules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' },],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' },],
                captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' },]
            },
            remember: false
        }
    },
    methods: {
        //获取验证码
        async getCaptcha() {
            const res = await this.$api.common.getCaptcha()
            this.formData.captcha_id = res.data.captcha_id
            this.img_base64 = res.data.img_base64
        },
        // 登录
        async login() {
            this.$refs.formRef.validate(async (vaild) => {
                if (!vaild) return;
                this.initErrMsg()
                const res = await this.$api.admin.login(this.formData)
                if (res.code != 200) {
                    console.log(res)
                    for (let k in res.data) {
                        this.errMsg[k] = res.data[k]
                    }
                    this.getCaptcha()
                    return
                }
                let auth = {
                    uuid: res.data.uuid,
                    secret_key: res.data.secret_key
                }
                sessionStorage.setItem('auth', JSON.stringify(auth))
                if (this.remember) {
                    localStorage.setItem('auth', JSON.stringify(auth))
                }
                this.$message.success("登录成功!")
                this.$router.push("/")
            });
        },
        reset() {
            this.formData = {
                username: '',
                password: '',
                captcha: '',
                captcha_id: '',
            }
            this.getCaptcha()
        },
        //初始化错误信息对象
        initErrMsg() {
            this.errMsg = {}
            this.$refs.formRef.fields.map(i => {
                this.$set(this.errMsg, i.prop, '')
            })
        },
    }
};
</script>
<style lang='less' scoped>
.image-slot {
    background-color: #F5F7FA;
    text-align: center;
    font-size: 16px;
    color: #c0c4cc;
}

.fz-16 {
    font-size: 16px;
}

.fz-20 {
    font-size: 20px;
}

.fc-blue {
    color: #409EFF;
}
</style>
